var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeartBlueLs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "29px",
    viewBox: "0 0 32 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHeartBlueLS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.40370662,2.4885 C4.00707862,0.83024928 6.11521462,0 8.22620662,3.81987775e-14 C10.3371986,3.81987775e-14 12.4559426,0.83025264 14.0593486,2.4885 L15.9824566,4.4835 L17.9055986,2.499 C21.1123766,-0.81756528 26.3544633,-0.81749136 29.5612073,2.499 C32.7679853,5.81549472 32.7679853,11.1419986 29.5612073,14.4584966 C25.1972053,18.9718502 20.8351746,23.4902438 16.4712066,28.0034966 C16.3427557,28.1376936 16.1640745,28.2137257 15.9771526,28.2137257 C15.7902308,28.2137257 15.6115495,28.1376936 15.4830986,28.0034966 L2.40370662,14.4479798 C-0.799399278,11.1289147 -0.803071278,5.80494096 2.40370662,2.4885 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icHeartBlueLS",
    fill: "#56A2FE",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartBlueLs);
export default __webpack_public_path__ + "static/media/icHeartBlueLS.9094ffe38b57236564acbe898beece0a.svg";
export { ForwardRef as ReactComponent };